// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'styled/components/Icon/Icon';
import { IconOuterProps } from 'styled/components/Icon/Icon.types';

const UtilitySmallStrokeArrowLeftIcon = (props: IconOuterProps) => (
  <Icon {...props} size="small">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.15401 11.6504C3.95875 11.8456 3.95875 12.1622 4.15401 12.3575L9.05636 17.2598C9.25162 17.4551 9.5682 17.4551 9.76346 17.2598C9.95873 17.0645 9.95873 16.748 9.76346 16.5527L5.71463 12.5039L19.5388 12.5039C19.8149 12.5039 20.0388 12.28 20.0388 12.0039C20.0388 11.7277 19.8149 11.5039 19.5388 11.5039L5.71472 11.5039L9.76346 7.45512C9.95873 7.25985 9.95873 6.94327 9.76346 6.74801C9.5682 6.55275 9.25162 6.55275 9.05636 6.74801L4.15401 11.6504Z"
      fill="var(--icon-color-main)"
    />
  </Icon>
);

export default UtilitySmallStrokeArrowLeftIcon;
